export const CalculatorKeys = {
	all: ["calculator"] as const,
	dashboardPermissions: () =>
		[...CalculatorKeys.all, "dashboardPermissions"] as const,
};
